<template>
  <div id="app" style="position: relative">
    <transition :name="direction"> <!--动态获得transition 的name值-->
      <!--<keep-alive include="commodity">-->
       <!---->
      <!--</keep-alive>-->
      <router-view class="viewbox" style="position: absolute;left: 0;top: 0"/>
    </transition>
  </div>
</template>

<script>
  import {custom_page} from './assets/js/api'
export default {
  name: 'App',
  mounted(){
    if (this.$router.history.current.name !== 'signature' && (!localStorage.getItem('logindata') || !localStorage.getItem('userdata'))){
      this.$router.push({ path: '/'});
    }

    //購物車內的字段顯示和隱藏(全局)
    custom_page().then(data=>{

      if (data.status){
        this.$store.commit('set_page_state', data.data) //頁面的顯示和隱藏數據
        if (localStorage.getItem('userdata')){
          this.$store.commit('set_list_class',Number(JSON.parse(localStorage.getItem('userdata')).users_role)) //用户角色
          //根據當前用戶身份顯示字段
          if (this.$store.state.list_class === 0){
            // this.Order_list_fields = this.$store.state.page_state.order_custom_yg
            this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom_yg)
          }
          else if (this.$store.state.list_class === 1){
            // this.Order_list_fields = this.$store.state.page_state.order_custom
            this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom)
          }
          else if (this.$store.state.list_class === 2){
            // this.Order_list_fields = this.$store.state.page_state.order_custom_gys
            this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom_gys)
          }
        }
      }
    })

    // 判断用户是手机还是电脑用户
    if(!navigator.userAgent.match(/(phone|UC|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      this.$store.commit('set_client',false) //pc端
    }
    this.$store.commit('set_loginuserdata',JSON.parse(localStorage.getItem('userdata')))
  },
  computed: {
    direction () {
      const viewDir = this.$store.state.viewDirection
      let tranName = ''
      if (viewDir === 'left') {
        tranName = 'right'
      } else if (viewDir === 'right') {
        tranName = 'left'
      } else {
        tranName = 'fade'
      }
      return tranName
    },
  },
}
</script>

<style lang="less">
  @import "assets/less/base";
  .el-popup-parent--hidden{
    overflow: unset !important;
  }
#app {
  font-family: 'PingFangSC-Regular', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  .viewbox{
    width: 100%;
  }
  @media (min-width: @screen-xs-max) {
    .toptitle{
      z-index: 2000;
    }
    .PersonalCenter{
      /*height: auto !important;*/
      width: auto !important;
      background-color: #535353;
      color: #fff;
      /*padding: 0 10px;*/
      padding-left: 20px;
      padding-right: 20px;
      h1{
        margin: 50px auto !important;
      }
      button{
        cursor: pointer;
      }
    }
  }
}
.v-enter{opacity: 1;}
.v-enter-to{opacity: 1;}
.v-enter-active{transition: 1s;} /*定义过渡时间*/
.v-leave{opacity: 1;}
.v-leave-to{opacity: 1;}
.v-leave-active{transition: 1s;}

.left-enter{transform: translateX(100%)}/*100%代表在屏幕外*/
.left-enter-to{transform: translateX(0)}
.left-enter-active{transition:0.5s}
.left-leave{transform: translateX(0)}
.left-leave-to{transform: translateX(-100%)}
.left-leave-active{transition:0.5s}

.right-enter{transform: translateX(-100%)}/*-100%代表在屏幕外,屏幕的左边*/
 .right-enter-to{transform: translateX(0)}
 .right-leave{transform: translateX(0)}
.right-leave-to{transform: translateX(100%)}/*屏幕的右边*/
.right-enter-active{transition:0.5s}
.right-leave-active{transition:0.5s}
</style>



// WEBPACK FOOTER //
// src/App.vue